const INIT_URL = 'init_url';
const LOB = 'warehouse';

const DEFAULT_CREATE_VIEW_PAGINATION_OPTIONS = {
  RECORDS_PER_PAGE_OPTIONS: [5, 10, 20, 30],
  DEFAULT_RECORDS_PER_PAGE: 5,
  LINE_ITEMS_PER_PAGE: 20,
  DEFAULT_ORDERBY: 'customer_name',
  SORTBY_ASC: true,
};

export default {
  INIT_URL,
  LOB,
  DEFAULT_CREATE_VIEW_PAGINATION_OPTIONS,
};
